import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import WatchDemo from './../modals/watchADemo'
import Header from './Header';
import Footer from './Footer';

class PricingPage extends Component {

     render() {

        return (
            <Fragment>
                <Header {...this.props} />
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div style={{ 'paddingBottom': 0 }} className="content-box video-popup">
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h1>Invest in your coaching, training, or fitness business</h1>
                                        <p>One client or 10,000 clients is only $10 per month</p>
                                         <a className="btn circle btn-light border btn-md mar10"
                                            data-toggle="modal" data-target="#freedownload" >Try it free</a>
                                        <WatchDemo  mrgnClass={"mar10"}></WatchDemo>
                                        <p id="small-font">14 day free trial with hassle free cancellation</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="overview" className="work-list-area default-padding">
                    <div className="container">

                        <div className="row">

                            <div className="col-md-6 thumb text-center pull-right guarantee-main">
                                <img className="guarantee-image" src="assets/img/new-images/row1-pricing.png"
                                    width="250px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>The Fitbanx no risk, no hassle 60- day guarantee</h3>
                                <p>Fitbanx comes with a 100% money back guarantee.  No hassle, no strings attached. To read the entire no risk, no hassle 60-day guarantee policy straight from the founder, <a data-toggle="modal" data-target="#guarantee">click here​</a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center">
                                <img src="assets/img/new-images/pricing-row2.png" width="300px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>Free client & consumer download</h3>
                                <p>Your clients will never be charged to download and access the Fitbanx IOS or Android app.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img className="pricing-row3" src="assets/img/new-images/NEW-PIE-CHART.jpg"
                                    width="400px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Keep your profits</h3>
                                <p>Keep 100% of every dollar by using your own payment platform like PayPal or Venmo. You may also use the Fitbanx payment platform for extra convenience (optional). However, additional fees will apply if you utilize the optional Fitbanx platform (see graphic).</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center">
                                <img src="assets/img/new-images/updated-pricing.png" width="400px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>Flexible pricing structure</h3>
                                <p>
                                    You decide how to price the workouts and programs that you assign to your clients.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ 'paddingTop': 0 }} id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img className="guarantee-image" src="assets/img/new-images/pricing-row5.png"
                                    width="400px" alt="Thumb" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Subscription income</h3>
                                <p>It's time for you to turn your workout creativity and knowledge into passive, recurrent income. Fitbanx is the only platform that will allow you to sell individual workouts AND generate subscription income.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="features" className="features-area cell-items default-padding second-page-features">
                    <div className="container">
                        <h1 className="text-center">Still have questions? We've got answers</h1>
                        <div className="row">
                            <div className="features-items icon-solid">
                                <div className="col-md-12">
                                    <div className="items-box inc-cell">
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">

                                                <div className="info">
                                                    <h4>Will I be charged once I sign up?</h4>
                                                    <p>
                                                        Absolutely not. We will not charge you when you sign up for our free trial.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>Can I still enter the digital marketplace if I am not a trainer, coach, or fitness brand?</h4>
                                                    <p>Absolutely. Fitbanx is for anyone who wants to build and share digital workouts easily.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>How do I become a featured brand?</h4>
                                                    <p>
                                                        You have to submit a formal request by clicking <Link to={'/featureBrands'} >
                                          here
                                      </Link>. If you just want to build and share workouts, simply download our app and get started!
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>Can you summarize what Fitbanx will cost me?</h4>
                                                    <p>
                                                    The pricing is simple.  You pay $10 per month regardless of how many clients you have.  You keep 100% of every dollar earned if you use your OWN payment platform like PayPal or Venmo.  If you utilize the optional Fitbanx payment platform, then you will keep 85% of all membership sales and 70% of all individual workout sales. 
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>Will I have to sign a contract?</h4>
                                                    <p>Nope. Cancel anytime hassle free. We hate binding contracts because we believe that is an indication of a business with little value.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 equal-height2 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>How much content do I have to post?</h4>
                                                    <p>It's up to you and what works best for you. Like all things, the more you put in, the more you get out.</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div style={{ 'padding': '40px 0' }} className="content-box video-popup">
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h2>Start building and sharing your workouts today</h2>
                                        <a className="btn circle btn-light border btn-md" data-toggle="modal"
                                            data-target="#freedownload">Try it free</a>
                                        <WatchDemo></WatchDemo>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props} />


                <div className="modal fade" id="myModal1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                                <h4 className="modal-title">How do I generate referral income and how does it work?</h4>
                            </div>
                            <div className="modal-body">
                                <p>You will receive an unique referral link upon joining Fitbanx. Your unique referral link should be shared with all your friends, fans, followers and customers. Any customer who accesses the Fitbanx app will be linked to your payment portal and YOU will receive 85% of all subscription income generated by that customer.</p>
                                <p>For example, if a customer joins Fitbanx through your unique referral link and then decides to enter a paid subscription of one our Featured Brands, then you will still receive 85% of those subscription dues! So it pays to spread your unique referral link with everyone and anyone!</p>
                            </div>
                            <div className="modal-footer">
                                <   button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default PricingPage



// WEBPACK FOOTER //
// ./src/components/PricingPage.js